import { Outlet } from 'react-router-dom';

import { UpdateToast } from './pwa/UpdateToast';

/**
 * The pathless root route's element. Everything that must know the current
 * route but live above every workspace — today, only the "new version" toast,
 * which has to stay quiet on exam routes — hangs here.
 */
export function RootLayout(): JSX.Element {
  return (
    <>
      <Outlet />
      <UpdateToast />
    </>
  );
}
